<template>
  <div class="overflow-hidden py-4 border-b">
    <div class="float-left text-gray-600">
      <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
        <use xlink:href="/static/img/feather-sprite.svg#user-check"/>
      </svg>
    </div>

    <div class="" style="margin-left:50px;">
      <div class="text-sm">
        You logged in to {{ getAppName }}
      </div>

      <div class="mt-3 text-gray-600">
        {{ activity.created_at }}
      </div>
    </div>
  </div>
</template>

<script>

  import { EventBus } from '@/shared/event-bus';
  

  export default {

    props : {
      activity : {
        type    : Object,
        required: true
      },

    },
  }
</script>

<style scoped>

</style>
